<template>
  <div>
    <intro-header />
    <div>
      <div class="container">
        <div class="intromain bg-white">
          <component :is="currentComponent" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IntroHeader from "./introheader.vue";
import Resturants from "./Resturant/Resturants";
import shared from "../../sharedscripts/master/Intro.js";
export default {
  name: "Intro",
  components: {
    IntroHeader,
    Resturants
  },
  data() {
    return {
      ...shared.data()
    };
  }
};
</script>
